// 引入axios方法
import { fun_PostAction, fun_Download } from "@/api/index";
// 引入转译方法
import { fun_DownloadFile } from "@/utils/validate";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 列表loading状态
      loading: false,
      // 表头按钮组
      btnList: [
        {
          name: "添加",
          type: "success",
          icon: "document-add"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        },
      ],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 初始化表单对象
      form: {
        fileType: null, // 附件类型
        fileName: null, // 附件名称
      },
      // 查询表单
      formSearchList: [
        {
          type: "select",
          label: "附件类型：",
          value: "fileType",
          placeholder: "请选择",
          queryParams: {
            url: "/dataDictionaryEntries/DictionaryCombobox",
            zdid: "201510281920370002"
          }
        },
        {
          type: "input",
          label: "附件名称：",
          value: "fileName",
          placeholder: "请输入",
        },
      ],
      // 表头数据列
      tableColumns: [
        {
          label: "附件名称",
          prop: "fileName"
        },
        {
          label: "附件类型",
          prop: "fileTypeName"
        },
        {
          label: "上传时间",
          prop: "insertDate"
        },
        {
          label: "操作",
          slotName: "op"
        }
      ],
      // table数组
      tableData: [],
      multipleSelection: [],  
    };
  },
  // 模板编译完成
  mounted() {
    // 执行获取列表数据方法
    this.fun_GetList();
  },

  // 自定义方法
  methods: {
    /**
     * 获取列表数据
     * @params request 入参对象
     * @author 滕威
     */
    async fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction("/downloadCenter/list", {
          ...this.form,
          ...this.reqPageData
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选时执行的方法
     * @params val 勾选的value值
     * @author 滕威
     */
    fun_HandleSelectionChange(val) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = val;
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 滕威
     */
    fun_click(e) {
      // 如果是添加
      if(e == "添加"){
        // 调用添加方法
        this.fun_Add();
      }
      // 如果是修改
      else{
        // 调用删除方法
        this.fun_Del();
      }
    },
    /**
     * 查看详情
     * @params e 点击的行数据
     * @author 付翔
     */
    fun_Detail(e) {
      // 跳转详情页面
      this.$router.push({path: "/downloadCenterDetail", query: { id: e.id, type: "details" }});
    },
    /**
     * 新增方法
     */
    fun_Add(){
      // 跳转详情页面
      this.$router.push({path: "/downloadCenterDetail", query: { type: "insert" }});
    },
    /**
     * 删除方法
     * @author 滕威
     */
    fun_Del() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 主键数组
        let keys = [];
        // 遍历勾选
        for(const index in this.multipleSelection){
          // 赋值主键集合
          keys[index] = this.multipleSelection[index].id;
        }
        // 弹出询问confirm
        this.$confirm("是否确定删除选中数据？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // 请求，获取结果集
          fun_PostAction("/downloadCenter/delete", {
            keys: keys,
          }).then(res => {
            // 解构res.data
            const { msg } = res.data;
            // 操作成功
            this.$message.success(msg);
            // 获取一览表格数据
            this.fun_GetList();
          });
        });
      }
      // 如果未进行勾选
      else{
        // 提示，并清除选中数据
        this.$alert("最少选择一条数据！", "warning");
      }
    },
    /**
     * 下载
     * @param e
     */
    fun_Download(filePath,fileName){
      // 获取id
      fun_Download("/downloadLocal?filePath=" + filePath + "&fileName=" + fileName).then(res => {
        if (res) {
          if (res.data.type === "application/json") {
            this.$message.error("文件不存在！");
            return;
          }
          // 获取头部
          let fileNames = res.headers["content-disposition"]; //获取到Content-Disposition;filename
          let regFileNames = fileNames.match(/=(.*)$/)[1];
          fun_DownloadFile(res, decodeURIComponent(regFileNames));
        }
      });
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
  }
};
